export const POSTER_CATEGORIES = {
  SWMI: 'Solar Wind - Magnetosphere Interaction',
  MPS: 'Magnetotail and Plasma Sheet',
  IMAG: 'Inner MAGnetosphere',
  MIC: 'Magnetosphere – Ionosphere Coupling',
  GSM: 'Global System Modeling',
  Other: 'Other',
}
